import { render, staticRenderFns } from "./itemProduct.vue?vue&type=template&id=377e368d&scoped=true"
import script from "./itemProduct.vue?vue&type=script&lang=js"
export * from "./itemProduct.vue?vue&type=script&lang=js"
import style0 from "./itemProduct.vue?vue&type=style&index=0&id=377e368d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e368d",
  null
  
)

export default component.exports